<template>
  <div class="istarshine pt-60 px-5">
    <nav class="istarshine-tabs">
      <router-link
        :to="{ name: 'clients--client_id-projects--project_id-istarshine-' }"
        class="istarshine-tab"
        exact
      >{{ $t('istarshine.config_title') }}</router-link>
      <router-link
        :to="{ name: 'clients--client_id-projects--project_id-istarshine-backsearch' }"
        class="istarshine-tab"
      >{{ $t('istarshine.backsearch.title') }}</router-link>
    </nav>
    <router-view :key="pageIndex" :project-settings="projectSettings" />
  </div>
</template>

<script>
// Config
import { API_HOST } from '../config/app-const';

// Plugins
import {mapState} from 'vuex'
import axios from 'axios'

export default {
  name: "istarshine",

  props: {
    client_id: String,
    project_id: String,
  },

  beforeCreate() {
    const mains = document.getElementsByClassName('main')
    Array.from(mains).forEach(main => main.style.overflow = 'visible')
  },

  created() {
    // cache project_id and client_id on store
    this.$store.commit('booleanSearch/SET_CLIENT_ID', this.client_id)
    this.$store.commit('booleanSearch/SET_PROJECT_ID', this.project_id)

    // set baseUrl && Auth token for api calls
    axios.defaults.baseURL = API_HOST;
    axios.defaults.headers.common['Authorization'] = `Token token=${this.user.accessToken}`;
  },

  data() {
    return {
      pageIndex: 1
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user.data,
      projectSettings: state => state.projects.projectSettings.data,
    })
  }
}
</script>

<style lang="scss">
@import "../styles/components/boolean-search/index.scss";

.istarshine-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.istarshine-tab {
  padding: 0.6rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: #111827;
  }

  &.router-link-active {
    color: #00A6A6;
    border-bottom-color: #00A6A6;
  }
}
</style>

